import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const BarChart = ({ 
  data, 
  xKey, 
  yKey, 
  title, 
  color = "#10B981", 
  height = 300,
  showGrid = true,
  showLegend = true,
  showTooltip = true,
  horizontal = false
}) => {
  return (
    <div className="w-full">
      {title && (
        <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
          {title}
        </h3>
      )}
      <ResponsiveContainer width="100%" height={height}>
        <RechartsBarChart 
          data={data} 
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          layout={horizontal ? 'horizontal' : 'vertical'}
        >
          {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />}
          <XAxis 
            dataKey={horizontal ? yKey : xKey}
            stroke="#6B7280"
            fontSize={12}
            tickLine={false}
            axisLine={false}
            type={horizontal ? 'number' : 'category'}
          />
          <YAxis 
            dataKey={horizontal ? xKey : yKey}
            stroke="#6B7280"
            fontSize={12}
            tickLine={false}
            axisLine={false}
            type={horizontal ? 'category' : 'number'}
            tickFormatter={(value) => horizontal ? value : value.toLocaleString()}
          />
          {showTooltip && (
            <Tooltip 
              contentStyle={{
                backgroundColor: 'rgb(var(--c-bg-white))',
                border: '1px solid rgb(var(--c-border-gray-200))',
                borderRadius: '8px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
              }}
              labelStyle={{ color: 'rgb(var(--c-text-gray-700))', fontWeight: '600' }}
            />
          )}
          {showLegend && <Legend />}
          <Bar 
            dataKey={horizontal ? xKey : yKey} 
            fill={color}
            radius={[4, 4, 0, 0]}
          />
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChart;
